module.exports = __webpack_public_path__ + "static/media/img85_R.b8b5f7be.jpg";